import html from "./landing.html?raw";

// Public marketing landing shown at "/". Rendered in an isolated iframe so the
// landing's own styles never touch (or get touched by) the dashboard app's CSS.
// Links to /login use target="_top" to break out of the iframe into the SPA.
export default function Landing() {
  return (
    <iframe
      title="Mega Software"
      srcDoc={html}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: 0,
      }}
    />
  );
}
